export default "__VITE_ASSET__cbK4Ivej__"